import { generateTraceparent } from './traceparent';

/**
 * Pluggable active-context seam.
 *
 * Today odin has no inbound trace to continue, so each outbound request starts
 * a fresh root (the default provider). The later browser-RUM phase registers a
 * provider that returns the currently-active span's context — so the injection
 * call sites in the apps never need to change when that phase lands.
 */
export type TraceparentProvider = () => string | null;

let activeProvider: TraceparentProvider = generateTraceparent;

/** Override the active-context provider (e.g. browser-RUM, in a later phase). */
export const configureActiveTraceparentProvider = (provider: TraceparentProvider): void => {
  activeProvider = provider;
};

/** Restore the default fresh-root provider (test teardown / reset). */
export const resetActiveTraceparentProvider = (): void => {
  activeProvider = generateTraceparent;
};

/** The `traceparent` for the current outbound request, or `null` to omit it. */
export const getActiveTraceparent = (): string | null => activeProvider();
